import { createSlice } from '@reduxjs/toolkit';
import { SelectOption } from '../alerts/filters/filtersReducer';
import { systemAlertStatusCodes } from './alert-status/alertStatusesConstants';

export interface ScreeningFilterState {
  SANCTION: {
    selectedStatus: SelectOption;
    selectedEntityType: SelectOption;
  };
  PEP: {
    selectedStatus: SelectOption;
    selectedEntityType: SelectOption;
  };
  ADVERSE_MEDIA: {
    selectedStatus: SelectOption;
    selectedEntityType: SelectOption;
  };
  ADVERSE_MEDIA_ENTITY: {
    selectedStatus: SelectOption;
    selectedEntityType: SelectOption;
  };
  CUSTOM_SCREENING_LIST: {
    selectedStatus: SelectOption;
    selectedEntityType: SelectOption;
  };
}

export const initialState: ScreeningFilterState = {
  SANCTION: {
    selectedStatus: {
      key: systemAlertStatusCodes.new,
      value: systemAlertStatusCodes.new,
      label: 'New',
    },
    selectedEntityType: {
      key: '',
      value: '',
      label: 'All entities',
    },
  },
  PEP: {
    selectedStatus: {
      key: systemAlertStatusCodes.new,
      value: systemAlertStatusCodes.new,
      label: 'New',
    },
    selectedEntityType: {
      key: '',
      value: '',
      label: 'All entities',
    },
  },
  ADVERSE_MEDIA: {
    selectedStatus: {
      key: systemAlertStatusCodes.new,
      value: systemAlertStatusCodes.new,
      label: 'New',
    },
    selectedEntityType: {
      key: '',
      value: '',
      label: 'All entities',
    },
  },
  ADVERSE_MEDIA_ENTITY: {
    selectedStatus: {
      key: systemAlertStatusCodes.new,
      value: systemAlertStatusCodes.new,
      label: 'New',
    },
    selectedEntityType: {
      key: '',
      value: '',
      label: 'All entities',
    },
  },
  CUSTOM_SCREENING_LIST: {
    selectedStatus: {
      key: systemAlertStatusCodes.new,
      value: systemAlertStatusCodes.new,
      label: 'New',
    },
    selectedEntityType: {
      key: '',
      value: '',
      label: 'All entities',
    },
  },
};

const filtersSlice = createSlice({
  name: 'screeningFilters',
  initialState,
  reducers: {
    updateSelectedStatus: (state, action) => {
      // @ts-ignore
      state[action.payload.page].selectedStatus = action.payload.selected;
    },
    updateSelectedEntityType: (state, action) => {
      // @ts-ignore
      state[action.payload.page].selectedEntityType = action.payload.selected;
    },
  },
});

const { actions, reducer } = filtersSlice;

export const { updateSelectedStatus, updateSelectedEntityType } = actions;
export default reducer;
